import type { FiltersGroup, FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import type { FilterAvailabilityContext, FilterGroupDescriptor } from '@/app/common/filters/groups/groupDescriptors.ts';
import { FILTER_GROUPS } from '@/app/common/filters/groups/groupDescriptors.ts';

export const walkFilterGroups =
  <Context extends FilterAvailabilityContext>(descriptors: FilterGroupDescriptor<Context>[]) =>
  (context: Context): FiltersGroups =>
    descriptors
      .filter((descriptor) => !descriptor.available || descriptor.available(context))
      .map((descriptor) => ({
        descriptor,
        group: {
          id: descriptor.id,
          label: descriptor.label(context),
          filters: descriptor.createFilters(context),
          ...(descriptor.showMore && { showMore: descriptor.showMore }),
        } satisfies FiltersGroup,
      }))
      .filter(({ descriptor, group }) => !descriptor.visibility || descriptor.visibility(group, context))
      .map(({ group }) => group);

export const buildFilterGroups = walkFilterGroups(FILTER_GROUPS);
